import styled from 'styled-components';
import { LinkBadgeType } from '../VerticalNav/hooks/useLinkBadgeData';
import UpgradeArrow from '../icons/UpgradeArrow';
import Popover from '../Popover';
import LinkBadgeTooltip from './LinkBadgeTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledLinkBadgeDiv = styled.div.withConfig({
  displayName: "LinkBadge__StyledLinkBadgeDiv",
  componentId: "byrp7k-0"
})(["display:inline-flex !important;align-self:center;"]);
const StyledSpan = styled.span.withConfig({
  displayName: "LinkBadge__StyledSpan",
  componentId: "byrp7k-1"
})(({
  theme: _theme,
  type
}) => {
  const theme = _theme;
  const baseStyles = {
    fontWeight: '700 !important',
    fontSize: '10px !important',
    textShadow: '0 0 1px transparent !important',
    borderRadius: `${theme.borderRadius['200']} !important`,
    color: `${theme.color['text-core-on-fill-default']} !important`,
    display: 'inline-flex !important',
    lineHeight: '20px',
    margin: '0',
    minHeight: '20px !important',
    padding: `${theme.space['0']} ${theme.space['200']} !important`,
    textAlign: 'center',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };
  if (type === LinkBadgeType.comingSoon || type === LinkBadgeType.beta) {
    return Object.assign({}, baseStyles, {
      backgroundColor: `${theme.color['fill-accent-purple-default']} !important`
    });
  }
  return Object.assign({}, baseStyles, {
    backgroundColor: `${theme.color['fill-accent-green-default']} !important`
  });
});
const LinkBadge = ({
  type,
  text,
  tooltipText = '',
  tooltipPlacement = 'right',
  tooltipTarget,
  tooltipPadding,
  isHovering = false,
  tooltipId
}) => {
  return /*#__PURE__*/_jsx(Popover, {
    isOpen: !!tooltipText && isHovering,
    placement: tooltipPlacement,
    target: tooltipTarget,
    content: /*#__PURE__*/_jsx(LinkBadgeTooltip, {
      id: tooltipId,
      text: tooltipText
    }),
    padding: tooltipPadding,
    children: /*#__PURE__*/_jsxs(StyledLinkBadgeDiv, {
      children: [type === LinkBadgeType.comingSoon || type === LinkBadgeType.beta || type === LinkBadgeType.new ? /*#__PURE__*/_jsx(StyledSpan, {
        type: type,
        children: text
      }) : null, type === LinkBadgeType.upgradeArrow ? /*#__PURE__*/_jsx(UpgradeArrow, {}) : null]
    })
  });
};
export default LinkBadge;